import { Link } from "react-router-dom";

export function NotFoundRecovery({
  to,
  linkLabel,
}: {
  to: string;
  linkLabel: string;
}) {
  return (
    <section className="panel" aria-labelledby="not-found-heading">
      <h1 id="not-found-heading">Page not found</h1>
      <p className="muted">That address may be outdated or no longer available.</p>
      <Link to={to}>{linkLabel}</Link>
    </section>
  );
}

export function StaffNotFoundRecovery({
  destination,
}: {
  destination: string;
}) {
  const linkLabel = destination === "/today"
    ? "Return to Today"
    : destination === "/waiting"
      ? "Return to Action Centre"
      : "Return to Diary";

  return (
    <NotFoundRecovery
      to={destination}
      linkLabel={linkLabel}
    />
  );
}
